import React, { useMemo } from 'react';

import Box from '@material-ui/core/Box';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';

import ExpandIcon from '@material-ui/icons/ExpandMore';

import useAccountUsers from 'selectors/users/use-account-users';
import useCourses from 'selectors/courses/use-courses';
import CourseCard from './course-card';

export default function InactiveCoursesSection() {
  const data = useData();

  if (data.length === 0) {
    return null;
  }

  return (
    <Box clone mb={2}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandIcon />}>
          <Typography variant="h5">Inactive courses ({data.length})</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Box>
            {data.map(({ user, course }) => (
              <CourseCard
                key={user.courseId}
                userStatus={user.status}
                courseStatus={course?.status}
                role={user.role}
                courseId={user.courseId}
                school={course?.school}
                code={course?.code}
                title={course?.title}
                semester={course?.semester}
                year={course?.year}
              />
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

function useData() {
  const users = useAccountUsers();
  const courseIds = useMemo(() => users.map((u) => u.courseId), [users]);
  const courses = useCourses(courseIds);
  const data = useMemo(
    () =>
      users
        .map((user, i) => ({ user, course: courses[i] }))
        .filter(({ course }) => course?.status === 'archived'),

    [users, courses]
  );
  return data;
}
